module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    ref: "picker",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetimerange",
      "range-separator": "To",
      "default-time": ['00:00:00', '23:59:59'],
      "start-placeholder": "Start Date",
      "end-placeholder": "End Date",
      "picker-options": _vm.pickerOptions,
      "format": "dd-MM-yyyy HH:mm:ss"
    },
    on: {
      "input": _vm.handleChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36d43450","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/filters/DateRangeFilter.vue
// module id = 3219
// module chunks = 3